module.exports = require("next/dist/compiled/@edge-runtime/ponyfill");